import styled from 'styled-components';

export const ProfileMainWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        border-radius: 1rem;
        border: 1px solid ${props.theme.colors.grey.lighte7};
        background-color: ${props.theme.colors.white.base};
        margin-bottom: ${props.theme.spacing.large.l15};
        position: relative;
    `,
);

export const ProfileInnerWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        flex-direction: column;
    `,
);

export const ProfileHeadOuterWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l20} 0;
        @media(max-width:768px){
            padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l20} 0;
        }
    `,
);

export const ProfileHeadInnerWrap = styled.div(
  props => `
        width:90%;
        display: flex;
        flex-direction: column;
        border-left: 6px solid ${props.theme.colors.grey.lightba};
        padding-left: ${props.theme.spacing.large.l30};
        @media (max-width: 768px){
            width:100%;
        }
    `,
);

export const HeadMainText = styled.p(
  props => `
        font-size: ${props.theme.font.large.font30};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.medium};
        line-height: 1;
        @media(max-width:768px){
            font-size: ${props.theme.font.large.font24};
        }
    `,
);

export const HeadSubText = styled.span(
  props => `
        font-size: ${props.theme.font.large.font18};
        color: ${props.theme.colors.grey.base};
        padding-top: ${props.theme.spacing.small.s5};
        @media(max-width:768px){
            font-size: ${props.theme.font.large.font14};
        }
    `,
);

export const HeaderEditTag = styled.div(
  props => `
        display: flex;
        justify-content: flex-end;
        border: 1px solid ${props.theme.colors.grey.lighte7};
        padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l20};
        border-radius: 3rem;
        height: 4rem;
        align-items: center;
        jusitfy-content: center;
        cursor: pointer;
        @media(max-width:768px){
            padding: ${props.theme.spacing.small.s7} ${props.theme.spacing.large.l15};
            height:3rem;
        }
    `,
);

export const EditText = styled.p(
  props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.blue.base};
        font-weight: ${props.theme.font.fontWeight.medium};
        cursor: pointer;
        margin-left: ${props.theme.spacing.small.s3};
    `,
);

export const ProfileInfoOuterWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        padding: 0 0 0 ${props.theme.spacing.large.l30};
        flex-direction: column;
    `,
);

export const ProfileInfoInnerWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l20} 0 ;
        border-bottom: 1px solid ${props.theme.colors.grey.lighte7};
        align-items: center;
        &:hover{
            background:${props.theme.colors.white.bgWhite1};
        }

        &:last-of-type{
            //border-bottom: none;
        }

        @media (max-width: 768px){
            flex-direction:column;
            align-items: flex-start;
        }
    `,
);

export const AadharInfoInnerWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l20} 0 ;
        align-items: center;
        @media (max-width: 768px){
            flex-direction: column;
            align-items: flex-start;
        }
    `,
);

export const InfoTitleWrap = styled.div(
  props => `
        width:40%;
        display: flex;
        @media(max-width:768px){
            width:100%;
        }
    `,
);

export const TitleText = styled.p(
  props => `
        font-size: ${props.theme.font.small.font11};
        color: ${props.theme.colors.grey.base};
        text-transform: uppercase;
        @media(max-width:768px){
            font-size: ${props.theme.font.large.font14};
        }
    `,
);

export const InfoTextWrap = styled.div(
  props => `
        width:60%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        @media (max-width: 768px){
            flex-wrap: wrap;
            width:100%;
            position:relative;
            padding-top: ${props.theme.spacing.small.s5};
        }
    `,
);

export const InfoTextWrapIvr = styled.div(
  props => `
        width:60%;
        display: flex;
        // align-items: center;
        // justify-content: space-between;
        flex-direction: column;
        @media (max-width: 768px){
            width:100%;
            position:relative;
            padding-top: ${props.theme.spacing.small.s5};
        }
    `,
);

export const InfoText = styled.p(
  props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.medium};
        @media(max-width:768px){
            font-size: ${props.theme.font.large.font18};
        }
    `,
);

export const AddInfoText = styled.p(
  props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.blue.base};
        font-weight: ${props.theme.font.fontWeight.medium};
        cursor: pointer;
    `,
);

export const VerifiedTag = styled.div(
  props => `
        display: flex;
        justify-content: flex-end;
        align-items: center;
        @media(max-width:768px){
            position: initial;
            top:-1.8rem;
            right:0;
        }
    `,
);

export const VerifiedText = styled.p(
  props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.green.light2f};
        font-weight: ${props.theme.font.fontWeight.medium};
        padding-left: ${props.theme.spacing.small.s5};
    `,
);

export const DeleteIconWrap = styled.div(
  props => `
        position: relative;
        &:hover{
            ${DeleteToolTip}{
                display: flex;
            }
        }
    `,
);

export const DeleteToolTip = styled.div(
  props => `
        width:34rem;
        background-color: ${props.theme.colors.white.base};
        padding: ${props.theme.spacing.large.l20};
        display: none;
        flex-direction: column;
        box-shadow: 0 11px 50px 0 rgba(0, 0, 0, 0.22);
        position: absolute;
        right: -2rem;
        top: 3rem;
        z-index: 2;

        &:after{
            content: '';
            position: absolute;
            right: 2rem;
            top: -1rem;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-bottom: 10px solid #fff;
            box-shadow: 0 11px 50px 0 rgba(0, 0, 0, 0.22);
        }
    `,
);

export const ConfirmText = styled.p(
  props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
    `,
);

export const UserOtionWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: ${props.theme.spacing.large.l15};
    `,
);

export const CancelLink = styled.a(
  props => `
        font-size: ${props.theme.base};
        color: ${props.theme.colors.grey.base};
        font-weight: ${props.theme.font.fontWeight.black};
        text-decoration: none;
        text-transform: uppercase;
        cursor: pointer;
        &:hover{
            color: ${props.theme.colors.grey.base};
        }
    `,
);

export const ConfirmLink = styled.a(
  props => `
        font-size: ${props.theme.base};
        color: ${props.theme.colors.red.base};
        font-weight: ${props.theme.font.fontWeight.black};
        text-decoration: none;
        text-transform: uppercase;
        margin-left: ${props.theme.spacing.large.l30};
        cursor: pointer;
        &:hover{
            color: ${props.theme.colors.red.base};
        }
    `,
);

export const AadharForm = styled.form(
  props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        @media(max-width: 768px){
            flex-direction: column;
            align-items: flex-start;
        }
    `,
);

export const CommonInput = styled.input(
  props => `
        width: 70%;
        height: 3rem;
        border-left: 0;
        border-right: 0;
        border-top: 0;
        border-bottom: 1px solid ${props.theme.colors.grey.lightd0};
        background-color: transparent;
        border-radius: ${props.theme.misc.borderRadius.small};
        font-size: ${props.theme.font.large.font16};
        padding-left: ${props.theme.spacing.small.s5};
        color: ${props.theme.colors.grey.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        position: relative;
        cursor: pointer;
        ::placeholder {
            lin-height: ${props.theme.font.lineHeight.large};
            font-size: ${props.theme.font.large.font16};
            color: ${props.theme.colors.grey.lightc5};
            overflow: visible;
        }
        :focus{
            border-left: 0;
            border-right: 0;
            border-top: 0;
            border-bottom: 1px solid ${props.theme.colors.grey.lightd0};
            outline: none;
        }
        @media only screen and (min-width: 320px) and (max-width: 991px) {
            font-size: ${props.theme.font.large.font14};
        }
        opacity: ${props.disabled ? '0.4' : '1'};
        pointer-events: ${props.disabled ? 'none' : ''};
        border-color: ${props.hasError ? props.theme.colors.red.base : ''};
        text-transform: ${props.isPAN ? props.theme.font.textTransform.upper : ''};
`,
);

export const VerifyBtn = styled.button(
  props => `
        background-color: ${props.theme.colors.blue.base};
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.white.base};
        font-weight: bold;
        outline: none;
        border: none;
        border-radius: .4rem;
        margin-left: ${props.theme.spacing.large.l20};
        height:3rem;
        display: flex;
        align-items: center;
        justify-content: center;
        width:10rem;
        text-transform: uppercase;
        cursor: pointer;
        @media(max-width: 768px){
            width:100%;
            margin-left:0;
            margin-top:${props.theme.spacing.large.l15};
        }
    `,
);

export const EditBtn = styled.button(
  props => `
        background-color: ${props.theme.colors.green.base};
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.white.base};
        font-weight: bold;
        outline: none;
        border: none;
        border-radius: .4rem;
        margin-left: ${props.theme.spacing.large.l20};
        height:3rem;
        display: flex;
        align-items: center;
        justify-content: center;
        width:10rem;
        text-transform: uppercase;
        cursor: pointer;
    `,
);

export const ErrorText = styled.span(
  props => `
          color: ${props.theme.colors.red.base};
          font-size: ${props.theme.font.small.font10};
          padding-top: ${props.theme.spacing.small.s3};
          font-weight : ${props.weight || ''};
          display : flex;
      `,
);

export const ErrorTextDiv = styled.div(
  props => `
          color: ${props.theme.colors.red.base};
          font-size: ${props.fontSize || props.theme.font.small.font10};
          padding-top: ${props.theme.spacing.small.s3};
          font-weight : ${props.weight || ''};
          display : flex;
          margin-right : 1rem;
          padding-top : ${props.paddingTop || ''};
          @media(max-width:768px){
              margin-top: 0;
          }
      `,
);

export const AadharInputWrap = styled.div(
  props => `
        width:70%;
        display: flex;
        flex-direction: column;
        @media(max-width: 768px){
            width:100%;
        }
    `,
);

export const InfoWrapper = styled.div(
  props => `
        display: flex;
    `,
);

export const VerifyEmailLink = styled.a(
  props => `
        text-decoration: none;
        font-size:1.4rem;
        color: #0091ff;
        font-weight: 900;
        cursor: pointer;
    `,
);

export const InfoSubText = styled.span(
  props => `
        font-size:1.1rem;
        color: #4a4a4a;
        line-height: 1.2;
        margin-left: 1rem;
    `,
);
